module.exports = __webpack_public_path__ + "static/img/unsub_icon.1b02166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unsub_icon.png
// module id = ALrc
// module chunks = 1